import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { func } from 'prop-types'
import {
  selectLabels,
  // selectAccessibilityResources,
  // selectAccessibilityModalContent,
  // selectAccessibilityCardContent,
  selectAccommodationsContent
} from '../../redux/configuration/selectors'

import { selectCrossingData } from '../../redux/crossings/selectors'

import { ENABLE_ACCOMMODATIONS, appRoutes } from '../../configuration/constants'

// ************ ACTIONS *************
import {
  setActiveDepartureAccommodations,
  setActiveReturnAccommodations
} from '../../redux/activeAccommodations/actions'
import { fetchCrossing } from '../../redux/crossings/actions'
import {
  updateDepartureAccommodations,
  updateReturnAccommodations
} from '../../redux/userSelections/actions'

import { selectActiveCrossings } from '../../redux/activeCrossings/selectors'

import { selectLanguage } from '../../redux/session/selectors'
/*
import {
  selectAccessibilityResponses,
  selectAccessibilityResponseCount
} from '../../redux/accessibility/selectors'
*/
import { selectKennelCardDetails } from '../../redux/selectors/selectKennelCardDetails'
// import { setAccessibilityResponses } from '../../redux/accessibility/actions'
// import * as UserSelectionActions from '../../redux/userSelections/actions'
import selectKennelQuantitiesCardState from '../../redux/selectors/selectKennelQuantitiesCardState'
// import appRoutes from '../../configuration/appRoutes'

// import ExtrasCard from '../../components/ExtrasCard/ExtrasCard'
import KennelQuantitiesCard from '../../components/KennelQuantitiesCard/KennelQuantitiesCard'
// import AccessibilityModal from '../../components/AccessibilityModal/AccessibilityModal'
import {
  selectActiveRouteForm,
  selectDepartureRoute
} from '../../redux/ferryRouteSelections/selectors'
import { selectActiveModifyBooking } from '../../redux/modifyBooking/selectors'
import BrandLoader from '../../components/BrandLoader/BrandLoader'

import '../../styles/scss/components/extras/extras.scss'

const ExtrasContainer = ({ handleRouteChange }) => {
  const labels = useSelector(selectLabels)
  const lang = useSelector(selectLanguage)
  const dispatch = useDispatch()
  const crossings = useSelector(selectActiveCrossings)
  const kennelCardDetails = useSelector(selectKennelCardDetails)
  const kennelSelectionState = useSelector(selectKennelQuantitiesCardState)
  const accommodationsContent = useSelector(selectAccommodationsContent)
  const activeRouteForm = useSelector(selectActiveRouteForm)
  const activeModifyBooking = useSelector(selectActiveModifyBooking)
  const departureRoute = useSelector(selectDepartureRoute)
  const isBfl = departureRoute.ferryId === 'bfl'

  const crossingState = useSelector(selectCrossingData)

  const isLoading =
    crossingState?.departure?.loading || crossingState?.return?.loading

  useEffect(() => {
    dispatch(
      fetchCrossing('departure', { fetchAllAccommodationResources: true })
    )
    if (activeRouteForm === 'RT') {
      dispatch(
        fetchCrossing('return', { fetchAllAccommodationResources: true })
      )
    }

    if (activeModifyBooking) {
      if (
        activeModifyBooking?.departureAccommodations &&
        ENABLE_ACCOMMODATIONS
      ) {
        dispatch(
          updateDepartureAccommodations(
            activeModifyBooking?.departureAccommodations
          )
        )
        // TODO: deprecate
        dispatch(
          setActiveDepartureAccommodations(
            activeModifyBooking?.departureAccommodations
          )
        )
      }

      if (activeModifyBooking?.returnAccommodations && ENABLE_ACCOMMODATIONS) {
        dispatch(
          updateReturnAccommodations(activeModifyBooking?.returnAccommodations)
        )
        // TODO: deprecate
        dispatch(
          setActiveReturnAccommodations(
            activeModifyBooking?.returnAccommodations
          )
        )
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  /*
  const accessibilityCardDetails = {
    buttonText: `${labels.selectAccessibilityOptions} (${accessibilityResponseCount})`,
    imageUrl: accessibilityCardContent?.imageUrl,
    content: accessibilityCardContent?.value
  }
  */
  /*
  const handleAccessibilitySave = values => {
    dispatch(setAccessibilityResponses(values)) // TODO: Deprecate
    dispatch(UserSelectionActions.setAccessibilityResponses(values))
  }
  */

  if (
    isLoading ||
    !crossings?.departure ||
    crossings?.loading ||
    !kennelSelectionState
  ) {
    return <BrandLoader />
  }

  return (
    <div className="extras u-container u-page-view-container">
      <div className="extras__content">
        <h2 className="theme-font-header">{labels.extras}</h2>
        <div className="extras__card-container">
          {/* right card */}
          {kennelCardDetails && (
            <KennelQuantitiesCard
              {...kennelCardDetails}
              crossing={crossings?.departure}
              labels={labels}
              selections={kennelSelectionState}
              accommodationsContent={accommodationsContent}
              startingFrom={false}
              onConfirmClick={selectedQuantities => {
                dispatch(
                  setActiveDepartureAccommodations(selectedQuantities.departure)
                )
              }}
              direction="departure"
              header={labels.departureRoute}
              lang={lang}
              loading={crossings?.loading}
              pageTitle={labels['pets'] || 'Pets'}
              content={
                isBfl
                  ? `<p>${labels.travellingWithPetsBFL}</p><p>${labels.travellingWithPetsMsgPar1BFL}</p><p>${labels.travellingWithPetsMsgPar2}</p>`
                  : `<p>${labels.travellingWithPets}</p><p>${labels.travellingWithPetsMsgPar1}</p><p>${labels.travellingWithPetsMsgPar2}</p>`
              }
            />
          )}

          {kennelCardDetails && crossings?.return && (
            <KennelQuantitiesCard
              {...kennelCardDetails}
              crossing={crossings?.return}
              labels={labels}
              selections={kennelSelectionState}
              accommodationsContent={accommodationsContent}
              startingFrom={false}
              onConfirmClick={selectedQuantities => {
                dispatch(
                  setActiveReturnAccommodations(selectedQuantities.return)
                )
              }}
              direction="return"
              header={labels.returnRoute}
              lang={lang}
              loading={crossings?.loading}
            />
          )}
        </div>
      </div>
      {/*
      <AccessibilityModal
        labels={labels}
        isOpen={accessibilityModalVisible}
        options={accessibilityModalOptions}
        values={accessibilityResponses}
        contentValues={accessibilityModalContent}
        onSave={handleAccessibilitySave}
        onRequestClose={() => setAccessibilityModalVisible(false)}
        /> */}
      <div className="u-page-submit-container">
        <button
          className="btn btn-primary large-primary-btn"
          onClick={() => handleRouteChange(appRoutes.summary.pathname)}
        >
          {labels.continueToSummaryBtn} →
        </button>
      </div>
    </div>
  )
}

ExtrasContainer.propTypes = {
  handleRouteChange: func.isRequired
}

export default ExtrasContainer
